import { render, staticRenderFns } from "./CardNew.vue?vue&type=template&id=16dfbf55&"
import script from "./CardNew.vue?vue&type=script&lang=js&"
export * from "./CardNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports